import React from 'react';
import { motion } from 'framer-motion';

const VirtualKeyboard = ({ onKeyPress, onBackspace, onSubmit, onClear }) => {
  const keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['+', '0', '⌫']
  ];

  const handleKeyClick = (key) => {
    if (key === '⌫') {
      onBackspace();
    } else {
      onKeyPress(key);
    }
  };

  const keyVariants = {
    hover: { scale: 1.1, backgroundColor: '#667eea' },
    tap: { scale: 0.95 }
  };

  return (
    <div className="virtual-keyboard">
      {keys.map((row, rowIndex) => (
        <div key={rowIndex} className="keyboard-row">
          {row.map((key) => (
            <motion.button
              key={key}
              className={`keyboard-key ${key === '⌫' ? 'backspace' : ''}`}
              onClick={() => handleKeyClick(key)}
              variants={keyVariants}
              whileHover="hover"
              whileTap="tap"
            >
              {key}
            </motion.button>
          ))}
        </div>
      ))}
      <div className="keyboard-actions">
        <motion.button
          className="keyboard-action-btn clear"
          onClick={onClear}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Clear
        </motion.button>
        <motion.button
          className="keyboard-action-btn submit"
          onClick={onSubmit}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Submit
        </motion.button>
      </div>
    </div>
  );
};

export default VirtualKeyboard;




